/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  PostV2PrototypesShareAnonymousReviewByShareTokenParams,
  PostV2PrototypesShareAnonymousReviewFinishByShareTokenAndReviewIdParams,
  PostV2PrototypesShareAnonymousReviewFeedbackByShareTokenAndReviewIdParams,
  PostV2PrototypesShareAnonymousReviewByShareTokenBody,
  PostV2PrototypesShareAnonymousReviewFinishByShareTokenAndReviewIdBody,
  PostV2PrototypesShareAnonymousReviewFeedbackByShareTokenAndReviewIdBody,
  PostV2PrototypesShareAnonymousReviewByShareTokenResponse,
  PostV2PrototypesShareAnonymousReviewFinishByShareTokenAndReviewIdResponse,
  PostV2PrototypesShareAnonymousReviewFeedbackByShareTokenAndReviewIdResponse,
} from '../types';

export class PrototypesAnonymousReview extends Controller {
  async postV2PrototypesShareAnonymousReviewByShareToken<
    T extends PostV2PrototypesShareAnonymousReviewByShareTokenResponse,
    D,
    C extends PostV2PrototypesShareAnonymousReviewByShareTokenBody
  >(
    body: C,
    { shareToken }: PostV2PrototypesShareAnonymousReviewByShareTokenParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/share/${shareToken}/anonymous/review`,
      body,
      axiosConfig
    );
  }

  async postV2PrototypesShareAnonymousReviewFinishByShareTokenAndReviewId<
    T extends PostV2PrototypesShareAnonymousReviewFinishByShareTokenAndReviewIdResponse,
    D,
    C extends PostV2PrototypesShareAnonymousReviewFinishByShareTokenAndReviewIdBody
  >(
    body: C,
    {
      shareToken,
      reviewId,
    }: PostV2PrototypesShareAnonymousReviewFinishByShareTokenAndReviewIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/share/${shareToken}/anonymous/review/${reviewId}/finish`,
      body,
      axiosConfig
    );
  }

  async postV2PrototypesShareAnonymousReviewFeedbackByShareTokenAndReviewId<
    T extends PostV2PrototypesShareAnonymousReviewFeedbackByShareTokenAndReviewIdResponse,
    D,
    C extends PostV2PrototypesShareAnonymousReviewFeedbackByShareTokenAndReviewIdBody
  >(
    body: C,
    {
      shareToken,
      reviewId,
    }: PostV2PrototypesShareAnonymousReviewFeedbackByShareTokenAndReviewIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/share/${shareToken}/anonymous/review/${reviewId}/feedback`,
      body,
      axiosConfig
    );
  }
}
